import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { ActionLink } from './util/action-link';
import { scenarioNames } from './util/constants';
import { notificationQueueHeaderTitleStyle } from './css/style';

export const Header = props => (
  <div className="notification-queue-header">
    <div className="notification-queue-header-content-wrapper">
      <h2
        className="title"
        style={notificationQueueHeaderTitleStyle}
      >
        {props.title}
      </h2>
      {props.text && <ActionLink
        {..._.omit(props, 'title')}
        scenarioName={scenarioNames.ViewAll}
      />}
      <hr />
    </div>
  </div>
);

Header.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};

Header.defaultProps = {
  text: undefined,
};
